/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Sticky mobile CTA bar — appears after scrolling past the hero.
 * Only visible below md breakpoint.
 */

"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { isWaitlistMode, openWaitlist } from "@/lib/utils/waitlist-mode";

export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past ~80% of viewport height (hero)
      setVisible(window.scrollY > window.innerHeight * 0.8);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background/95 backdrop-blur-sm border-t border-border px-4 py-3 safe-area-bottom">
      <Button
        size="default"
        className="w-full bg-secondary hover:bg-secondary/90 text-white font-medium shadow-lg h-12 text-base"
        onClick={() => {
          if (isWaitlistMode()) {
            openWaitlist();
          } else {
            window.location.href = "/auth/sign-up";
          }
        }}
      >
        {isWaitlistMode() ? "Join the Waitlist" : "Start Your Free Trial"}
      </Button>
    </div>
  );
}
